/** Body metrics chart — `user_chart.setting.selected_metrics` (0 = athlete profile metrics). */

export interface MetricsChartSettings {
  selected_metrics?: number[];
  chart_title?: string;
  date_range?: Record<string, unknown>;
  [key: string]: unknown;
}

export const PROFILE_METRICS_SENTINEL = 0;

export function usesProfileMetrics(selected: number[] | undefined): boolean {
  if (!selected || selected.length === 0) return true;
  return selected.length === 1 && selected[0] === PROFILE_METRICS_SENTINEL;
}

export function mergeMetricsChartSettings(raw: Record<string, unknown>): MetricsChartSettings {
  const selected = raw.selected_metrics;
  return {
    ...raw,
    selected_metrics: Array.isArray(selected)
      ? selected.map((id) => Number(id)).filter((id) => Number.isFinite(id))
      : [PROFILE_METRICS_SENTINEL],
  };
}

export function buildMetricsSettingPayload(
  useProfile: boolean,
  pickedIds: number[],
): MetricsChartSettings {
  if (useProfile) {
    return { selected_metrics: [PROFILE_METRICS_SENTINEL], metrics_default_initialized: true };
  }
  return { selected_metrics: pickedIds.length ? pickedIds : [PROFILE_METRICS_SENTINEL], metrics_default_initialized: true };
}
